import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, LinearProgress, Button } from "@material-ui/core";
import { Club } from "api/clubs";
import { OwnerClubSettings, patchPublicity } from "api/owner/settings";
import { useSnackbar } from "notistack";
import moment from "moment";
import i18n from "../i18n";

// prop types
interface ChangeClubVisibilityDialogProps {
    club?: Club,
    ownerSettings?: OwnerClubSettings,
    show: boolean,
    onClose: () => void,
    onFetchUserProfile: () => void,
}

// change club visibility dialog
const ChangeClubVisibilityDialog = ({ club, ownerSettings, show, onClose, onFetchUserProfile }: ChangeClubVisibilityDialogProps) => {
    // snackbar
    const { enqueueSnackbar } = useSnackbar();
    const displayError = (error: any) => enqueueSnackbar(
        `${i18n.anErrorOccurred}: ${error.description} (${error.type})`,
        { variant: "error" },
    );

    // ui state
    const [isLoading, setLoading] = useState(false);

    // execute action
    const execute = async () => {
        setLoading(true);
        try {
            await patchPublicity({
                clubId: club!.id,
                isPublic: club!.clubStatus === "private",
            });
            onFetchUserProfile(); // refresh
            enqueueSnackbar(i18n.visibilityChangedSuccessfully, { variant: "success" });
            onClose();
        } catch (error) {
            displayError(error);
        }
        setLoading(false);
    };

    // render
    const lastChange = moment(ownerSettings?.lastPublicityChange || club?.createdAt).format("DD.MM.YYYY HH:mm");
    return (
        <Dialog open={show} onClose={onClose}>
            <DialogTitle>{i18n.changeClubVisibility}</DialogTitle>
            <DialogContent dividers>
                <DialogContentText>
                    {(club?.clubStatus === "private") ? i18n.privateClubDesc(lastChange) : i18n.publicClubDesc(lastChange)}
                </DialogContentText>
                <DialogContentText>
                    {!ownerSettings?.stripeAccountId && i18n.stripeRequired}
                </DialogContentText>
            </DialogContent>
            {isLoading && <LinearProgress />}
            <DialogActions>
                <Button color="secondary" onClick={() => window.open("https://help.playsports.world/article/182-was-ist-der-unterschied-zwischen-dem-vereinsstatus-privat-und-public")} style={{ marginRight: "auto" }}>
                    {i18n.moreInformation}
                </Button>
                <Button color="secondary" onClick={onClose}>
                    {i18n.cancel}
                </Button>
                <Button style={ownerSettings?.stripeAccountId ? { color: "#d44336" } : {}} disabled={isLoading || !ownerSettings?.stripeAccountId} onClick={execute}>
                    {(club?.clubStatus === "private") ? i18n.makePublic : i18n.makePrivate}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChangeClubVisibilityDialog;
